export default "__VITE_ASSET__933f0368__"